import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'hasPermissionToViewCandidatesList',
      'hasPermissionToCreateCandidate',
      'hasPermissionToEditCandidate',
      'hasPermissionToVerifyCandidate',
      'hasPermissionToDeleteCandidate',
      'hasPermissionToFinalizeCandidate',
      'hasPermissionToPromoteCandidate'
    ])
  }
}
